/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Datastore API
 * API reference for Datastore API.
 *
 * Authentication: Auth0
 *
 * OpenAPI spec version: 3.0.0
 */
import type {
  GetOrganizationNotificationSettingsResponse,
  UpdateOrganizationNotificationSettingsRequestBody,
  UpdateOrganizationNotificationSettingsResponse
} from '../model';

import getOrganizationNotificationSettingsMutator from '../../../mutators/datastore-instance';
import putOrganizationNotificationSettingsMutator from '../../../mutators/datastore-instance';



  /**
 * 組織通知設定を取得する
 * @summary 組織通知設定取得
 */
export const getOrganizationNotificationSettings = (

 ) => {
      return getOrganizationNotificationSettingsMutator<GetOrganizationNotificationSettingsResponse>(
      {url: `/organization-notification-settings`, method: 'GET'
    },
      );
    }
  /**
 * 組織通知設定を更新する
 * @summary 組織通知設定更新
 */
export const putOrganizationNotificationSettings = (
    updateOrganizationNotificationSettingsRequestBody?: UpdateOrganizationNotificationSettingsRequestBody,
 ) => {
      return putOrganizationNotificationSettingsMutator<UpdateOrganizationNotificationSettingsResponse>(
      {url: `/organization-notification-settings`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: updateOrganizationNotificationSettingsRequestBody
    },
      );
    }
  export type GetOrganizationNotificationSettingsResult = NonNullable<Awaited<ReturnType<typeof getOrganizationNotificationSettings>>>
export type PutOrganizationNotificationSettingsResult = NonNullable<Awaited<ReturnType<typeof putOrganizationNotificationSettings>>>
